import { Calendar } from '@powerportalspro/react-calendar';
import { ACCOUNT_ID } from '../demos/DetailPageRecords';

// Schmeler and Sons, the account the detail page demos feature.
const account = { tableName: 'account', id: ACCOUNT_ID };

export function CalendarMainSample() {
  return <Calendar regarding={account} defaultLayout="month" />;
}
